export default [
    {
        path: '/osIndex',
        name: 'osIndex',
        component: () => import('@/views/osSystem/index.vue'),
        meta: {
            title: '首页'
        }
    },
    {
        path: '/appClick',
        name: 'appClick',
        component: () => import('@/views/osSystem/bi/appClick.vue'),
        meta: {
            title: '用户行为'
        }
    },
    {
        path: '/appClickList',
        name: 'appClickList',
        component: () => import('@/views/osSystem/list/appClickList.vue'),
        meta: {
            title: '用户行为日志'
        }
    },
    {
        path: '/osDeviceActivated',
        name: 'osDeviceActivated',
        component: () => import('@/views/osSystem/bi/osDeviceActivated.vue'),
        meta: {
            title: '设备激活'
        }
    },
    {
        path: '/osDeviceActivatedList',
        name: 'osDeviceActivatedList',
        component: () => import('@/views/osSystem/list/osDeviceActivatedList.vue'),
        meta: {
            title: '设备激活日志'
        }
    },
    {
        path: '/osMachineList',
        name: 'osMachineList',
        component: ()=>import('@/views/osSystem/deviceManage/machineList'),
        meta: {
            title: '机型管理'
        }
    },
    {
        path: '/osAddModelPage',
        name: 'osAddModelPage',
        meta: {
            title: '新增机型'
        },
        component: () => import('@/views/osSystem/deviceManage/addModelPage')
    },{
        path: '/osEditModelPage',
        name: 'osEditModelPage',
        meta: {
            title: '编辑机型'
        },
        component: () => import('@/views/osSystem/deviceManage/editModelPage')
    },{
        path: '/osCheckModel',
        name: 'osCheckModel',
        meta: {
            title: '查看机型'
        },
        component: () => import('@/views/osSystem/deviceManage/checkModel')
    },{
        path: '/osOtaManger',
        name: 'osOtaManger',
        component: () => import('@/views/osSystem/apply/otaManger'),
        meta: {
            title: 'OTA管理'
        }
    },{
        path: '/osAppManager',
        name: 'osAppManager',
        component: () => import('@/views/osSystem/apply/appManager'),
        meta: {
            title: 'APP管理'
        }
    }
    ,{
        path: '/osOtaUpdateAddPage',
        name: 'osOtaUpdateAddPage',
        meta: {
            title: 'OTA新增'
        },
        component: () => import('@/views/osSystem/apply/otaUpdateAddPage')
    },{
        path: '/osOtaUpdateEditPage',
        name: 'osOtaUpdateEditPage',
        meta: {
            title: 'OTA编辑'
        },
        component: () => import('@/views/osSystem/apply/otaUpdateEditPage')
    },{
        path: '/osAppUpdateAddPage',
        name: 'osAppUpdateAddPage',
        meta: {
            title: 'App新增'
        },
        component: () => import('@/views/osSystem/apply/appUpdateAddPage')
    },{
        path: '/osAppUpdateEditPage',
        name: 'osAppUpdateEditPage',
        meta: {
            title: 'App编辑'
        },
        component: () => import('@/views/osSystem/apply/appUpdateEditPage')
    },{
        path: '/osApkUpdateAddPage',
        name: 'osApkUpdateAddPage',
        meta: {
            title: 'Apk新增'
        },
        component: () => import('@/views/osSystem/apply/apkUpdateAddPage')
    },{
        path: '/osApkUpdateEditPage',
        name: 'osApkUpdateEditPage',
        meta: {
            title: 'Apk编辑'
        },
        component: () => import('@/views/osSystem/apply/apkUpdateEditPage')
    },{
        path: '/osApkManager',
        name: 'osApkManager',
        meta: {
            title: 'APK管理'
        },
        component: () => import('@/views/osSystem/apply/apkManager')
    },{
        path: '/osOtaDownloadLogs',
        name: 'osOtaDownloadLogs',
        component: () => import('@/views/osSystem/apply/otaDownloadLogs'),
        meta: {
            title: 'OTA升级记录'
        }
    },{
      path: '/eventList',
      name: 'eventList',
      component: () => import('@/views/osSystem/list/eventList.vue'),
      meta: {
        title: '事件日志'
      },
    },{
      path: '/OTAUpgradesLog',
      name: 'OTAUpgradesLog',
      component:() => import('@/views/osSystem/list/OTAUpgradesLog'),
      meta: {
        title: 'ota升级日志'
      }
    },{
      path: "/apkDownloadView",
      name: 'apkDownloadView',
      component:() => import('@/views/osSystem/bi/apkDownloadView.vue'),
      meta: {
        title: 'apkDownloadView'
      }
    },{
    path: "/countryAppView",
    name: 'countryAppView',
    component:() => import('@/views/osSystem/bi/countryAppView.vue'),
    meta: {
      title: 'countryAppView'
      }
    }
    ,{
    path: "/appTopView",
    name: 'appTopView',
    component:() => import('@/views/osSystem/bi/appTopView.vue'),
    meta: {
      title: 'appTopView'
    }
  },
  {
    path: '/apkClickList',
    name: 'apkClickList',
    component: () => import('@/views/osSystem/list/apkClickList.vue'),
    meta: {
      title: '相框设备行为日志'
    }
  },
  {
    path: '/mobileAppUsagePageList',
    name: 'mobileAppUsagePageList',
    component: () => import('@/views/osSystem/list/mobileAppUsagePageList.vue'),
    meta: {
      title: 'mobileApp行为'
    }
  },
  {
    path: '/osOTADevice',
    name: 'osOTADevice',
    component: () => import('@/views/osSystem/list/OTADevice.vue'),
    meta: {
      title: 'OTA设备列表'
    }
  },
  {
    path: '/mobileAppUsage',
    name: 'mobileAppUsage',
    component: () => import('@/views/osSystem/list/mobileAppUsage.vue'),
    meta: {
      title: '手机App用户行为'
    }
  },
  {
    path: '/funnelChart',
    name: 'funnelChart',
    component: () => import('@/views/osSystem/bi/funnelChart.vue'),
    meta: {
      title: '漏斗图'
    }
  }



]



// WEBPACK FOOTER //
// ./src/router/osRouter.js